import * as Settings from '@va/dashboard/api-client/Settings';
import * as Admin from './admin';
import { authenticateByInstance } from './auth';
import * as Website from './website';

export default {
  generateImpersonate: Admin.generateImpersonate,
  refreshImpersonateToken: Admin.refreshImpersonateToken,
  refreshToken: Admin.refreshToken,

  authenticate: authenticateByInstance,

  getWebsite: Website.getWebsite,
  createWebsite: Website.createWebsite,
  activateDirectAccess: Website.activateDirectAccess,
  updateSettings: Settings.updateSettings,
};
